import { useNavigate } from "react-router-dom";
import { ArrowLeft, History as HistoryIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LOGO_URL } from "@/lib/brand";

export const TricolorBar = () => (
  <div className="flex h-1 w-full">
    <div className="flex-1 bg-tricolor-green" />
    <div className="flex-1 bg-white" />
    <div className="flex-1 bg-tricolor-red" />
  </div>
);

export const FormHeader = ({ historyPath, historyLabel }) => {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-gray-200">
      <div className="max-w-3xl mx-auto px-4 py-2 grid grid-cols-[1fr_auto_1fr] items-center gap-2">
        <Button variant="ghost" size="icon" onClick={() => navigate("/")} data-testid="home-btn" className="text-buscema-green justify-self-start" aria-label="Home">
          <ArrowLeft className="w-5 h-5" />
        </Button>
        <img src={LOGO_URL} alt="Buscema Gastronomia" className="h-12 sm:h-16 w-auto" data-testid="brand-logo" />
        <Button
          variant="ghost"
          onClick={() => navigate(historyPath)}
          data-testid="go-to-history-btn"
          className="justify-self-end text-buscema-green hover:bg-buscema-green hover:text-white gap-2 h-11 font-semibold transition-colors"
        >
          <HistoryIcon className="w-5 h-5" /> <span className="hidden sm:inline">{historyLabel}</span>
        </Button>
      </div>
      <TricolorBar />
    </header>
  );
};
